























































































































import Vue from 'vue';

import {
  exhibition,
  Exhibition,
  options,
  calender,
} from 'mostra';

export type DataType = {
  exhibitionList: Exhibition[];
  currentPage: number;
  perPage: number;
  isForced: boolean;
  total: number;
};

export default Vue.extend({
  name: 'admin-admin-exhibition-index',
  data(): DataType {
    return {
      exhibitionList: [],
      currentPage: 1,
      perPage: 500,
      isForced: false,
      total: 0,
    };
  },
  computed: {
    isFirstPage(): boolean {
      return this.currentPage === 1;
    },
  },
  async mounted() {
    this.$loading(true);
    try {
      this.exhibitionList = await exhibition.loadExhibitionList(this.perPage, 1);
    } catch (error: any) {
      this.$error('取得に失敗しました。', error);
    } finally {
      this.$loading(false);
    }
  },
  watch: {
    async isForced(val: boolean) {
      this.$loading(true);
      try {
        this.exhibitionList = await exhibition.loadExhibitionList(this.perPage, 1, val);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = 1;
        this.$loading(false);
      }
    },
  },
  methods: {
    formatDateTime(dt: any) {
      return calender.formatDateTime(dt);
    },
    getPublishTypeText(publishType: number): string {
      return options.get(options.exhibitionPublishedTypes, publishType).text;
    },
    async onChangePage(targetPage: number) {
      this.$loading(true);
      try {
        this.exhibitionList = await exhibition.loadExhibitionList(this.perPage, targetPage, this.isForced);
      } catch (error: any) {
        this.$error('取得に失敗しました。', error);
      } finally {
        this.currentPage = targetPage;
        this.$loading(false);
      }
    },
    async onClickCountAllExhibitions() {
      this.total = await exhibition.countAllExhibitions();
    },
  },
});
